import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import NoImage from "assets/img/catalogue.jpg";
import { Grid } from "@mui/material";
import Menu from "./Menu";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TagFilter, {
  ActiveTagFilter,
  SolutionTagChips,
} from "components/Catalogue/tags";
import SolutionSearch from "components/Catalogue/search";
import { solutionTags, tagsInUse, filterSolutions } from "utils/solutionTags";

const useStyles = makeStyles({
  card: {
    width: "100%",
    "&:hover": {
      boxShadow: "rgb(38, 57, 77) 0px 20px 30px -10px",
    },
  },
  media: {
    height: 200,
    objectFit: "cover",
  },
});

export default function MediaCard(props) {
  const [blur, setBlur] = React.useState("");

  const classes = useStyles();
  // D30 (2)/(3): the same bottom-right search and tag filter as the main solutions page. This
  // page gets each solution's tag objects ({ _id, name }); the page wrapper keeps the search
  // text and the tag filter ({ selected, mode }).
  const tagsOf = (s) => solutionTags(s.tags);
  const tagsUsed = tagsInUse(props.services, tagsOf);
  const { mode } = props.tagFilter;
  // A remembered tag that none of these solutions carries any more is left out.
  const selectedTagIds = props.tagFilter.selected.filter((id) =>
    tagsUsed.some((t) => t.id === id)
  );
  const shownServices = filterSolutions(props.services, {
    query: props.search,
    selectedIds: selectedTagIds,
    mode,
    tagsOf,
  });
  const setSelectedTags = (ids) => props.setTagFilter({ selected: ids, mode });
  // Clicking a tag chip on a card adds that tag to the filter.
  const addTagToFilter = (id) => {
    if (!selectedTagIds.includes(id)) setSelectedTags([...selectedTagIds, id]);
  };

  return (
    <div>
      <ActiveTagFilter
        tags={tagsUsed.filter((t) => selectedTagIds.includes(t.id))}
        mode={mode}
        onRemove={(id) => setSelectedTags(selectedTagIds.filter((s) => s !== id))}
      />
      <Grid container spacing={2}>
        {shownServices.map((elm) => (
          <Grid key={elm._id} item xs={12} sm={6} md={4}>
            <div
              style={{
                position: "relative",
              }}
            >
              <Card className={classes.card}>
                <CardContent
                  style={{
                    position: "relative",
                    borderBottom: "1px solid #bfbec8",
                    filter: blur == elm._id ? "blur(2px)" : "",
                    transition: "0.5s ease",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h7"
                    component="strong"
                    style={{
                      userSelect: "none",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {elm.name}
                  </Typography>

                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                      style={{
                        userSelect: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {elm.description}
                    </Typography>
                    {elm?.vanish ? (
                      <AccessTimeIcon
                        style={{
                          height: "15px",
                          width: "15px",
                          color: "grey",
                          position: "relative",
                          left: "5px",
                          top: "3px",
                        }}
                      />
                    ) : null}
                  </span>
                  <div style={{ marginTop: 6 }}>
                    <SolutionTagChips
                      tags={tagsOf(elm)}
                      onTagClick={addTagToFilter}
                      justify="flex-start"
                    />
                  </div>
                </CardContent>
                <CardMedia
                  className={classes.media}
                  component="img"
                  style={{
                    height: 200,
                    filter: blur == elm._id ? "blur(2px)" : "",
                    transition: "0.5s ease",
                  }}
                  image={elm.logoPath ? elm.logoPath : NoImage}
                  title={elm.description}
                />
              </Card>
              <Menu
                key={elm._id}
                setBlur={setBlur}
                id={elm._id}
                service={elm}
                setSelected={props.setSelected}
                setDuplicationMode = {props.setDuplicationMode}
              />
            </div>
          </Grid>
        ))}
      </Grid>
      {!shownServices.length && (props.services || []).length ? (
        <p
          style={{
            textAlign: "center",
            fontSize: "20px",
            marginTop: "14%",
            color: "#c8c8c8",
          }}
        >
          No such solution found. Please adjust filters
        </p>
      ) : null}
      <SolutionSearch
        value={props.search}
        onChange={props.setSearch}
        name="solution-management-search"
      />
      <TagFilter
        tags={tagsUsed}
        selected={selectedTagIds}
        mode={mode}
        onApply={props.setTagFilter}
        name="solution-management-filter"
      />
    </div>
  );
}
